export const TABLE_HEADERS = {
  medications: [
    {
      text: "Medication Name",
      align: "start",
      sortable: true,
      value: "Medication",
    },
    { text: "Med Class", value: "MedClass" },
    { text: "Prescribed By", value: "PrescribedBy.Name" },
    { text: "Physician Instructions", value: "Instructions", width: "20%" },
    { text: "Admin Time", value: "AdminTime" },
    { text: "RX", value: "RXNumber" },
    { text: "Actions", value: "actions", sortable: false },
  ],
  services: [
    {
      text: "Start Date",
      align: "start",
      sortable: false,
      value: "StartDate",
      width: "15%",
    },
    { text: "Status", value: "Active" },
    { text: "Service Item", value: "ServiceItem" },
    { text: "Scheduled Time", value: "ScheduledTime" },
    { text: "Instructions", value: "Instructions", width: "40%" },
    { text: "Actions", value: "actions", sortable: false },
  ],
  adls: [
    {
      text: "Date",
      align: "start",
      sortable: true,
      value: "FormattedDate",
    },
    { text: "Client", value: "ClientName" },
    { text: "Service", value: "Service" },
    { text: "Type", value: "ServiceType" },
    { text: "Time", value: "Time" },
    { text: "Notes", value: "ServiceNotes" },
    { text: "Signature", value: "Signature" },
  ],
  mars: [
    {
      text: "Date",
      align: "start",
      sortable: false,
      value: "FormattedDate",
    },
    { text: "Medication", value: "Medication.Medication" },
    { text: "Client", value: "ClientName" },
    { text: "Amount Administered", value: "AmountAdministered" },
    { text: "Admin Time", value: "AdminTime" },
    { text: "Actual Admin Time", value: "ActualAdminTime" },
    { text: "Notes", value: "Notes" },
    { text: "Exception", value: "Exception" },
    { text: "Signature", value: "Signature", sortable: false },
    { text: "Verified By", value: "VerifiedBy" },
  ],
  behaviors: [
    {
      text: "Date",
      align: "start",
      sortable: false,
      value: "FormattedDateTime",
    },
    { text: "Client", value: "ClientName" },
    { text: "Program", value: "Program" },
    { text: "Shift", value: "Shift" },
    { text: "Intensity", value: "Intensity" },
    { text: "Motivator", value: "Motivator" },
    { text: "Completed By", value: "CompletedByFormatted" },
  ],
  "ut incidents": [
    {
      text: "Date Created",
      align: "start",
      sortable: false,
      value: "FormattedTodaysDate",
    },
    { text: "Client", align: "start", value: "ClientName" },
    {
      text: "Incident Date Time",
      value: "FormattedIncidentDateTime",
    },
    {
      text: "Incident Type",
      value: "Type",
    },
    {
      text: "Program",
      value: "Program",
    },
    {
      text: "DSPD/OL Notification Submitted",
      value: "ReportSubmitted",
    },
    {
      text: "Signature",
      value: "StaffSignature",
    },
  ],
};

export const getTableHeaders = (reportType) => {
  return TABLE_HEADERS[reportType] || [];
};
